// extracted by mini-css-extract-plugin
export default {"fourthsection":"Fourth_fourthsection__dggyn","title":"Fourth_title__81J7v","experiences":"Fourth_experiences__N8IMW"};